import { useEffect, useState } from "react";
import BotaoContato from "../../componentes/BotaoContato/BotaoContato.js";
import "../ServicosEngAplicadaProjTec/ServicosEngAplicadaProjTec.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import Servicos from "../Servicos/Servicos.js";

function ServicosConsultoriaGesAmbiental() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div>
     <BannerPaginaInterna
  tag="Gestão e Monitoramento Ambiental"
  titulo="Consultoria, Gestão e Monitoramento Ambiental"
  descricao="Consultoria, Gestão e Monitoramento Ambiental com foco em conformidade, eficiência e sustentabilidade."
  textoBotao="Solicitar Orçamento"
  rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para Consultoria e Gestão Ambiental"
  mostrarBotaoOutline={true}
  textoBotaoOutline="Fale com Especialista"
  rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em consultoria e gestão ambiental"
/>

      <main className="servicos-page py-5">
        {/* HEADER */}

        {/* LISTA COM DETAILS */}
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Nossos Serviços Especializados</h2>
            <p>
              Clique nos itens abaixo para conhecer detalhes de nossa atuação
              técnica.
            </p>
          </div>

<p>
  A Âmbar Soluções em Engenharia e Meio Ambiente é especializada em <strong>consultoria ambiental, gestão ambiental e monitoramento ambiental</strong>, oferecendo suporte técnico completo para empresas que precisam de <strong>regularização ambiental, atendimento a condicionantes e cumprimento da legislação ambiental</strong>. Atuamos com foco em eficiência, conformidade legal e redução de riscos ambientais.
</p>

<p>
  Nossos serviços incluem <strong>gestão de condicionantes ambientais, monitoramento de desempenho ambiental, elaboração de relatórios técnicos</strong> e controle de obrigações como <strong>MTR, CTF/APP, CTF/AIDA, TCFA, DAURH, DCP, RAPP e DCC</strong>. Desenvolvemos também <strong>diagnósticos ambientais e avaliações estratégicas</strong>, auxiliando empresas na tomada de decisão e na melhoria contínua dos processos.
</p>

<p className="mb-4">
  Realizamos ainda o <strong>monitoramento de áreas em recuperação ambiental e plantios compensatórios</strong>, garantindo acompanhamento técnico, relatórios e recomendações de manejo. Com <strong>alto rigor técnico, atendimento personalizado e experiência junto a órgãos ambientais</strong>, entregamos soluções completas em <strong>consultoria e gestão ambiental</strong> para diversos segmentos.
</p>

          <div className="accordion">
            <div className="accordion">
{/* ITEM 01 */}
<details className="item" open={openItem === 1} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 1 ? null : 1); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Atendimento e monitoramento de condicionantes ambientais</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Realizamos o acompanhamento técnico de <strong>condicionantes ambientais</strong> estabelecidas em
        <strong> licenças ambientais</strong>, garantindo o cumprimento de prazos, exigências legais e obrigações técnicas.
        <br />
        O serviço inclui <strong>controle de cronogramas</strong>, <strong>elaboração de relatórios</strong> e
        <strong> interface com órgãos ambientais</strong>, reduzindo riscos de autuações e passivos ambientais.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Condicionantes Ambientais"
      />
    </div>
  </div>
</details>

{/* ITEM 02 */}
<details className="item" open={openItem === 2} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 2 ? null : 2); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Monitoramento de índice de desempenho ambiental</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Desenvolvemos e acompanhamos <strong>indicadores de desempenho ambiental</strong>, permitindo a avaliação contínua
        da eficiência das medidas de controle e gestão implementadas.
        <br />
        O monitoramento é realizado com base em <strong>parâmetros técnicos</strong> e
        <strong> exigências legais</strong>, auxiliando na <strong>tomada de decisão</strong> e melhoria contínua.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Desempenho Ambiental"
      />
    </div>
  </div>
</details>

{/* ITEM 03 */}
<details className="item" open={openItem === 3} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 3 ? null : 3); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Diagnóstico e avaliação ambiental estratégica</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Realizamos <strong>diagnósticos ambientais</strong> e <strong>avaliações estratégicas</strong>, com foco na
        identificação de <strong>riscos</strong>, <strong>passivos</strong> e oportunidades de melhoria.
        <br />
        Esses estudos subsidiam decisões relacionadas à <strong>implantação</strong>, <strong>operação</strong> ou
        <strong> ampliação de empreendimentos</strong>.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Diagnóstico Ambiental"
      />
    </div>
  </div>
</details>

{/* ITEM 04 */}
<details className="item" open={openItem === 4} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 4 ? null : 4); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Gestão de resíduos via MTR</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Prestamos suporte completo na <strong>gestão de resíduos sólidos</strong> com uso do
        <strong> Manifesto de Transporte de Resíduos (MTR)</strong>, garantindo <strong>rastreabilidade</strong> e conformidade legal.
        <br />
        O serviço inclui <strong>controle documental</strong>, <strong>orientação técnica</strong> e acompanhamento dos fluxos de resíduos.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Gestão de Resíduos (MTR)"
      />
    </div>
  </div>
</details>

{/* ITEM 05 */}
<details className="item" open={openItem === 5} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 5 ? null : 5); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Gestão de cadastros no IBAMA: CTF-AIDA, APP e TCFA</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Realizamos a gestão e regularização de cadastros junto ao <strong>IBAMA</strong>, garantindo a
        <strong> regularidade ambiental federal</strong> e evitando penalidades.
      </p>

      <p className="subtitulo-descricao"><strong>Principais itens:</strong></p>
      <ul className="lista-servico-detalhada">
        <li><strong>CTF/APP</strong></li>
        <li><strong>CTF/AIDA</strong></li>
        <li><strong>TCFA</strong></li>
      </ul>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Cadastro no IBAMA"
      />
    </div>
  </div>
</details>

{/* ITEM 06 */}
<details className="item" open={openItem === 6} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 6 ? null : 6); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">DAURH, DCP, RAPP, DCC e interpretação da legislação</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Oferecemos suporte na elaboração e gestão de obrigações como
        <strong> DAURH</strong>, <strong>DCP</strong>, <strong>RAPP</strong> e <strong>DCC</strong>,
        além da <strong>interpretação técnica da legislação ambiental</strong>.
      </p>

      <p className="subtitulo-descricao"><strong>Principais itens:</strong></p>
      <ul className="lista-servico-detalhada">
        <li><strong>DAURH</strong></li>
        <li><strong>DCP</strong></li>
        <li><strong>RAPP</strong></li>
        <li><strong>DCC</strong></li>
      </ul>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Obrigações Ambientais"
      />
    </div>
  </div>
</details>

{/* ITEM 07 */}
<details className="item" open={openItem === 7} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 7 ? null : 7); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Monitoramento de área de plantio</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Executamos o monitoramento de <strong>áreas em recuperação ambiental</strong> e
        <strong> plantios compensatórios</strong>, avaliando o desenvolvimento da vegetação.
        <br />
        Inclui <strong>inspeções de campo</strong>, <strong>relatórios técnicos</strong> e
        <strong> recomendações de manejo</strong>.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Monitoramento de Plantio"
      />
    </div>
  </div>
</details>
              </div>  
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ServicosConsultoriaGesAmbiental;
